import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { DialogService } from '../../services/dialog/dialog.service';

export type Folder = {
  id: number;
  name: string;
  read_only?: boolean;
  owner?: string;
};

@Component({
  selector: 'folder-browser',
  templateUrl: './folder-browser.component.html',
  styleUrls: ['./folder-browser.component.less'],
  standalone: false,
})
export class FolderBrowserComponent {
  @Input() folders: Folder[] = [];
  @Output() folderSelected = new EventEmitter<number | null>();
  @Output() folderEditClicked = new EventEmitter<Folder>();
  @Output() folderRemoveClicked = new EventEmitter<Folder>();

  public menuItems: MenuItem[] = [];
  public activeFolder: Folder | null = null;
  @ViewChild('menu') menu!: Menu;

  constructor(private dialogService: DialogService) {}

  public selectFolder(folderId: number | null): void {
    this.folderSelected.emit(folderId);
  }

  public trackById(folder: Folder): number {
    return folder.id;
  }

  public openMenu(event: MouseEvent, folder: Folder): void {
    event.stopPropagation();
    event.preventDefault();
    this.activeFolder = folder;
    this.menuItems = [
      { label: 'Edit', icon: 'fa-solid fa-pen', command: () => this.folderEditClicked.emit(folder) },
      { label: 'Remove', icon: 'fa-solid fa-trash', command: () => this.dialogService.openDialog('removeFolder') },
    ];
    this.menu.toggle(event);
  }

  public confirmRemove(): void {
    if (this.activeFolder) {
      this.folderRemoveClicked.emit(this.activeFolder);
      this.dialogService.closeDialog('removeFolder');
      this.activeFolder = null;
    }
  }
}
